<template>
  <div class="category_list">
    <span class="category_title">Все категории</span>
    <ul class="main_category_wrap">
      <li v-for="item in items" :key="'category' + item.id" :class="{ active: active_category === item.id}">
        <span class="main_category" @click="toggleActive(item.id,item.name)">{{ item.name }}</span>
        <div class="sub_category" v-if="item.children">
          <label class="custom-checkbox" v-for="child in item.children" :key="'subcategory-'+child.id">
            <input type="checkbox" :value="child.id" v-model="selected_items">
            <span></span>
            <span>{{ child.name }} <span class="qty">{{ child.products_count }}</span></span>
          </label>
        </div>
      </li>
    </ul>
  </div>
</template>

<script>
import { mapMutations } from 'vuex'

export default {
  name: 'CategoryList',
  props: {
    items: {
      type: Array,
      default: () => []
    },
    selectedItems: {
      type: Array,
      default: () => {}
    }
  },
  data () {
    return {
      active_category: null
    }
  },
  computed: {
    selected_items: {
      get () {
        return this.selectedItems
      },
      set (val) {
        this.$emit('update:selectedItems', val)
        this.$nextTick(() => {
          this.$emit('change-filter')
        })
      }
    }
  },
  methods: {
    ...mapMutations('catalog', ['setCurrentCategoryName']),
    toggleActive (id, name) {
      if (this.active_category === id) {
        this.active_category = null
        this.setCurrentCategoryName(null)
      } else {
        this.active_category = id
        this.setCurrentCategoryName(name)
      }
      this.$emit('update:selectedItems', [this.active_category])
      this.$nextTick(() => {
        this.$emit('change-filter')
      })
    }
  },
  watch: {
    $route: {
      immediate: true,
      handler (to, from) {
        const categories = to.query.categories

        if (categories) {
          this.active_category = parseInt(categories)
        }
      }
    }
  }
}
</script>

<style scoped>

</style>
